import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Checkbox, Paragraph } from '@digdir/designsystemet-react';
import { Fragment } from 'react';

import { OppvarmingFormData } from '../../../../../types';
import { VarmesentralRadio } from '../../../common/varmesentralRadio';
import { StyledCard } from '../../../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { ServiceSisteToArRadio } from '../../../common/serviceSisteToArRadio';
import { VarmesystemBrukCheckboxes } from '../../../common/varmesystemBruk';
import { useElektrisitetValidation } from '../../useElektrisitetValidation';
import { elektrisitetSelectionFields } from '../../utils';
import { InstallertIOppvarmetRomRadio } from '../../../common/installertIOppvarmetRomRadio';
import { InstallasjonsArRadio } from '../../../../../../../components/installasjonsArRadio';

import { Fordelingssystem } from './fordelingssystem';

export const Elektrokjel = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateElektrisitetSelection } = useElektrisitetValidation();

  const oppvarmingBrukSelection = watch(`elektrisk.value.kjel.value.bruk`);
  const showVarmefordeling = oppvarmingBrukSelection?.romoppvarming;
  const kjelSelected = watch('elektrisk.value.kjel.selected');
  const elektrisitetSelectionError = formState.errors?.elektrisk?.value?.kjel?.selected;

  return (
    <StyledCard isActive={kjelSelected}>
      <Checkbox
        aria-invalid={!!elektrisitetSelectionError}
        label={t('elektrisitet.kjel.label')}
        {...register('elektrisk.value.kjel.selected', {
          validate: validateElektrisitetSelection,
          deps: elektrisitetSelectionFields,
          shouldUnregister: true
        })}
      />
      {kjelSelected && (
        <Fragment>
          <Paragraph>{t('elektrisitet.kjel.description')}</Paragraph>
          <InstallasjonsArRadio
            name={`elektrisk.value.kjel.value.varmesentral`}
            translationKeyPrefix={`form.oppvarming.elektrisitet.kjel.varmesentral.installasjonsAr`}
          />
          <VarmesentralRadio name="elektrisk.value.kjel.value.varmesentral.varmesentralType" />
          <InstallertIOppvarmetRomRadio name="elektrisk.value.kjel.value.varmesentral.installertIOppvarmetRom" />

          <InstallasjonsArRadio
            name={`elektrisk.value.kjel.value`}
            translationKeyPrefix={`form.oppvarming.elektrisitet.kjel.installasjonsAr`}
          />
          <ServiceSisteToArRadio name="elektrisk.value.kjel.value.serviceGjennomfortSiste2Ar" />

          <VarmesystemBrukCheckboxes name="elektrisk.value.kjel.value.bruk" />

          {showVarmefordeling && <Fordelingssystem />}
        </Fragment>
      )}
    </StyledCard>
  );
};
